import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';

export const GET_WORK_REPORTS_REQUEST = 'GET_WORK_REPORTS_REQUEST';
export const GET_WORK_REPORTS_SUCCESS = 'GET_WORK_REPORTS_SUCCESS';
export const GET_WORK_REPORTS_ERROR = 'GET_WORK_REPORTS_ERROR';

export const GET_WORK_REPORT_REQUEST = 'GET_WORK_REPORT_REQUEST';
export const GET_WORK_REPORT_SUCCESS = 'GET_WORK_REPORT_SUCCESS';
export const GET_WORK_REPORT_ERROR = 'GET_WORK_REPORT_ERROR';

export const CREATE_WORK_REPORTS_REQUEST = 'CREATE_WORK_REPORTS_REQUEST';
export const CREATE_WORK_REPORTS_SUCCESS = 'CREATE_WORK_REPORTS_SUCCESS';
export const CREATE_WORK_REPORTS_ERROR = 'CREATE_WORK_REPORTS_ERROR';

export const UPDATE_WORK_REPORT_REQUEST = 'UPDATE_WORK_REPORT_REQUEST';
export const UPDATE_WORK_REPORT_SUCCESS = 'UPDATE_WORK_REPORT_SUCCESS';
export const UPDATE_WORK_REPORT_ERROR = 'UPDATE_WORK_REPORT_ERROR';

export const DELETE_WORK_REPORT_REQUEST = 'DELETE_WORK_REPORT_REQUEST';
export const DELETE_WORK_REPORT_SUCCESS = 'DELETE_WORK_REPORT_SUCCESS';
export const DELETE_WORK_REPORT_ERROR = 'DELETE_WORK_REPORT_ERROR';

export const CLEAN_WORK_REPORTS = 'CLEAN_WORK_REPORTS';

// Get workReports
export function getWorkReports(query) {
    return async (dispatch) => {
        try {
            dispatch(getWorkReportsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/work-reports/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getWorkReportsSuccess, getWorkReportsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getWorkReportsError));
        }
    };
}
function getWorkReportsRequest() {
    return {
        type: GET_WORK_REPORTS_REQUEST,
        isFetching: true
    };
}
function getWorkReportsSuccess (payload) {
    return {
        type: GET_WORK_REPORTS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getWorkReportsError(errorMessage) {
    return {
        type: GET_WORK_REPORTS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get workReport
export function getWorkReport(workReportId) {

    return async (dispatch) => {
        try {
            dispatch(getWorkReportRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/work-reports/${workReportId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getWorkReportSuccess, getWorkReportError));
        } catch (err) {
            dispatch(utilsLib.response(err, getWorkReportError));
        }
    };
}
function getWorkReportRequest() {
    return {
        type: GET_WORK_REPORT_REQUEST,
        isFetching: true
    };
}
function getWorkReportSuccess (payload) {
    return {
        type: GET_WORK_REPORT_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getWorkReportError(errorMessage) {
    return {
        type: GET_WORK_REPORT_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create workReports
export function createWorkReports(workReports, options) {
    return async (dispatch) => {
        try {
            dispatch(createWorkReportsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/work-reports', {workReports, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createWorkReportsSuccess, createWorkReportsError));
        } catch (err) {
            dispatch(utilsLib.response(err, createWorkReportsError));
        }
    };
}
function createWorkReportsRequest() {
    return {
        type: CREATE_WORK_REPORTS_REQUEST,
        isFetching: true
    };
}
function createWorkReportsSuccess (payload) {
    return dispatch => {
        // Create notification for create workReport success
        dispatch(addNotification({
            message: 'Registros de trabajo añadidos correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_WORK_REPORTS_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createWorkReportsError(errorMessage) {
    return dispatch => {
        // Create notification for create workReport error
        dispatch(addNotification({
            message: 'Error al añadir los registros de trabajo',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_WORK_REPORTS_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update workReport
export function updateWorkReport(workReportId, workReport = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateWorkReportRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/work-reports/${workReportId}`, workReport, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateWorkReportSuccess, updateWorkReportError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateWorkReportError));
        }
    };
}
function updateWorkReportRequest() {
    return {
        type: UPDATE_WORK_REPORT_REQUEST,
        isFetching: true
    };
}
function updateWorkReportSuccess (payload) {
    return dispatch => {
        // Create notification for update workReport success
        dispatch(addNotification({
            message: 'Registro de trabajo actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_WORK_REPORT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateWorkReportError(errorMessage) {
    return dispatch => {
        // Create notification for update workReport error
        dispatch(addNotification({
            message: 'Error al actualizar el registro de trabajo',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_WORK_REPORT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete workReport
export function deleteWorkReport(workReportId) {

    return async (dispatch) => {
        try {
            dispatch(deleteWorkReportRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/work-reports/${workReportId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteWorkReportSuccess, deleteWorkReportError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteWorkReportError));
        }
    };
}
function deleteWorkReportRequest() {
    return {
        type: DELETE_WORK_REPORT_REQUEST,
        isFetching: true
    };
}
function deleteWorkReportSuccess (payload) {
    return dispatch => {
        // Create notification for delete workReport success
        dispatch(addNotification({
            message: 'Registro de trabajo eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_WORK_REPORT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteWorkReportError(errorMessage) {
    return dispatch => {
        // Create notification for delete workReport error
        dispatch(addNotification({
            message: 'Error al eliminar el registro de trabajo',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_WORK_REPORT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean workReports reducer
export function cleanWorkReports() {
    return {
        type: 'CLEAN_WORK_REPORTS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/work-reports.js